<style lang="scss" scoped>
</style>
<template>
  <div>
    <tj-title-bar :title="healthcheckBookTeam.teamName" :content="rangeText"></tj-title-bar>
    <section class="bb pl15 pr15 pt10 pb10 mt15 flex aic bg_fff">
      <p class="fs14 flex1">
        总人数：{{ total.healthcheckUserCount }}人
        已预约人数：<span class="color_green">{{ total.waitCheckCount }}</span>人
        未预约人数：<span class="color_red">{{ total.waitHandleCount }}</span>人
        已到检人数：<span class="color_main">{{ total.alredayCheckCount }}</span>人
      </p>
    </section>
    <div class="bg_fff pl15 pt15">
      <el-form inline :model="form" size="mini">
        <el-form-item label="姓名">
          <el-input v-model="form.healthcheckerName" placeholder="体检人姓名"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="form.age" placeholder="年龄"></el-input>
        </el-form-item>
        <el-form-item label="套餐名称">
          <el-input v-model="form.comboName" placeholder="套餐名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="体检人手机号"></el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="form.idcard" placeholder="体检人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.healthcheckStartTime"
                          placeholder="预约开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.healthcheckEndTime"
                          placeholder="预约结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">筛选</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="flex aic pb10">
        <span class="fs14">订单状态(可多选)：</span>
        <el-checkbox-group size="mini" v-model="form.orderStatusList">
          <el-checkbox-button v-for="city in statusArr" :label="city.id" :key="city.id">{{ city.name }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>

    <div class="mt15 bg_fff">
      <el-table border size="mini" :data="list">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="姓名" prop="healthcheckerName"></el-table-column>
        <el-table-column label="手机号" prop="healthcheckMobile"></el-table-column>
        <el-table-column label="身份证" prop="healthcheckerIdcard"></el-table-column>
        <el-table-column label="状态" prop="orderStatusDescription"></el-table-column>
        <el-table-column label="套餐" prop="_comboName"></el-table-column>
        <el-table-column label="预约时间" prop="appointmentTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" v-if="showYuyue(row)" @click="yuyue(row)">预约</el-button>
            <el-button type="text" size="mini" v-if="showGenggai(row)" @click="yuyue(row)">更改
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pt10 pb10">
        <el-pagination :total="page.total" :current-page="page.pageNum" background
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <dialog-tj-yuyue2 ref="yuyue" @error="showError" @ok="getData"></dialog-tj-yuyue2>
    <dialog-error ref="error"></dialog-error>
  </div>
</template>
<script>
import {orderStatusList} from "../config";
import {healthcheckService} from "../services/healthcheck";
import {getJsDataType} from "../../../common/lib/utils";
import {TjMixin} from "../mixin";
import DialogTjYuyue2 from "../components/dialog-tj-yuyue2";
import DialogError from "../components/dialog-error";
import TjTitleBar from "../components/tj-title-bar";
import dayjs from 'dayjs';

export default {
  name: 'tj-index',
  components: {TjTitleBar, DialogError, DialogTjYuyue2},
  mixins: [TjMixin],
  data() {
    return {
      statusArr: orderStatusList,
      form: {
        pageNum: 1,
        pageSize: 10,
        orderStatusList: []
      },
      list: [],
      page: {},
      total: {}
    }
  },
  computed: {
    rangeText() {
      const {startDate, endDate} = this.healthcheckBookTeam;
      const format = 'YYYY-MM-DD';
      return `预约日期范围：${dayjs(startDate).format(format)}~${dayjs(endDate).format(format)}`;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    pageChange(page) {
      this.form.pageNum = page;
      this.getData();
    },
    async getData() {
      const {form} = this;
      const teamId = this.healthcheckBookTeam.id;
      form.platTeamId = teamId;
      this.total = await healthcheckService.tjhyTotal(teamId);
      const {list, page} = await healthcheckService.tjOrderList(form);
      this.list = list;
      this.page = page;
    },
    yuyue(data) {
      this.$refs.yuyue.open(data);
    },
    reset() {
      for (let key in this.form) {
        const type = getJsDataType(this.form[key]);
        if (type === 'array') this.form[key] = [];
        else this.form[key] = undefined;
        this.form.pageNum = 1;
        this.form.pageSize = 10;
      }
      this.getData();
    },
    showError(status, list) {
      this.$refs.error.open(status, list);
    }
  },
}
</script>
